import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavController, NavParams, LoadingController, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FacebookPipe } from 'src/app/pipes/facebook/facebook.pipe';
import { SemRegistroComponent } from '../sem-registro/sem-registro';
import { VideoPlayerComponent } from '../video-player/video-player';
import { VimeoPipe } from 'src/app/pipes/vimeo/vimeo.pipe';
@Component({
  selector: 'app-noticia-videos',
  templateUrl: './noticia-videos.page.html',
  styleUrls: ['./noticia-videos.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    FacebookPipe,
    SemRegistroComponent,
    VideoPlayerComponent,
    VimeoPipe
  ],
})
export class NoticiaVideosPage implements OnInit {
  video: any = [];
  videos: any = [];
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public translate: TranslateService,
    public modalCtrl: ModalController,
  ) {
    this.videos = navParams.get('videos');
    this.video = this.videos.length > 0 ? this.videos[0] : {};
  }

  ngOnInit() { }

  openVideo(video: any) {
    if (this.video?.id !== video.id) {
      this.video = { ...video };
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
